/* eslint-disable react/prop-types */
import React from "react";
import { Grid, Typography, Chip } from "@material-ui/core";
import moment from "moment";
import { getStatus } from "./utils";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";

const DayHeaderContent = (props) => {
  const { args, events, dayWiseStatus, setLoading, handleDailyApproval, isChipClickable,setisChipClickable } =
    props;
  const { t } = useTranslation();
  
  const getTotalHoursForDay = () => {
    let weekDay = moment(args.date);
    let totalDurationMeal;
    let totalDurationActivities;
    for (let i = 0; i < events.length; i++) {
      if (
        moment(events[i].startStr).format("DDMM") == weekDay.format("DDMM") &&
        moment(events[i].endStr).format("DDMM") == weekDay.format("DDMM")
      ) {
        if (events[i].title?.toLowerCase() != "meal") {
          totalDurationActivities = moment
            .duration(moment(events[i].endStr).diff(moment(events[i].startStr)))
            .add(totalDurationActivities);
        } else {
          totalDurationMeal = moment
            .duration(moment(events[i].endStr).diff(moment(events[i].startStr)))
            .add(totalDurationMeal);
        }
      }

      if (
        moment(events[i].startStr).format("DDMM") == weekDay.format("DDMM") &&
        moment(events[i].endStr).format("DDMM") != weekDay.format("DDMM")
      ) {
        if (events[i].title.toLowerCase() != "meal") {
          totalDurationActivities = moment
            .duration(
              moment(events[i].startStr)
                .endOf("day")
                .diff(moment(events[i].startStr))
            )
            .add(totalDurationActivities);
        } else {
          totalDurationMeal = moment
            .duration(
              moment(events[i].startStr)
                .endOf("day")
                .diff(moment(events[i].startStr))
            )
            .add(totalDurationMeal);
        }
      }

      if (
        moment(events[i].startStr).format("DDMM") != weekDay.format("DDMM") &&
        moment(events[i].endStr).format("DDMM") == weekDay.format("DDMM")
      ) {
        if (events[i].title?.toLowerCase() != "meal") {
          totalDurationActivities = moment
            .duration(
              moment(events[i].endStr).diff(
                moment(events[i].endStr).startOf("day")
              )
            )
            .add(totalDurationActivities);
        } else {
          totalDurationMeal = moment
            .duration(
              moment(events[i].endStr).diff(
                moment(events[i].endStr).startOf("day")
              )
            )
            .add(totalDurationMeal);
        }
      }
    }

    if (totalDurationActivities) {
      let activityDuration = totalDurationActivities.asHours();
      if (isNaN(activityDuration)) {
        totalDurationActivities = 0;
      } else {
        totalDurationActivities = activityDuration.toFixed(2);
      }
    } else {
      totalDurationActivities = 0;
    }

    if (totalDurationMeal) {
      let mealDuration = totalDurationMeal.asHours();
      if (isNaN(mealDuration)) {
        totalDurationMeal = 0;
      } else {
        totalDurationMeal = mealDuration.toFixed(2);
      }
    } else {
      totalDurationMeal = 0;
    }
    let totalDuration =
      parseFloat(totalDurationActivities) + parseFloat(totalDurationMeal);
    totalDuration = parseFloat(totalDuration).toFixed(2);
    return totalDuration;
  };

  const handleDayHeaderClick = (day, events) => {
    // setLoading(true);
    setisChipClickable(!isChipClickable);
    let thisDayEvents = events.filter(
      (event) => event.extendedProps.outTS !='' && moment(event.endStr).format("DDMM") == day.format("DDMM")
    );
    console.log("clicked on day header", day, thisDayEvents);
    // setTimeout(() => {
    //   handleDailyApproval(day, thisDayEvents);
    //   setLoading(false);
    // }, 2000);
    handleDailyApproval(day, thisDayEvents);
  };
  const getHeaderStyle = (status, day, events) => {
    if (status == "Pending") {
      return (
        <Chip
          size="small"
          label={<Typography>{properCase(t("other.lblPending"))}</Typography>}
          style={{ backgroundColor: "#1B75BC1A", color: "#1B75BC" }}
          onClick={() => handleDayHeaderClick(day, events)}
          // clickable ={isChipClickable}
          disabled ={!isChipClickable}
        />
      );
    }
    if (status == "In Progress") {
      return (
        <Chip
          size="small"
          label={<Typography>{properCase(t("other.tlinProgress"))}</Typography>}
          style={{ backgroundColor: "#f7931e1A", color: "#f7931e" }}
        />
      );
    }
    if (status == "Approved") {
      return (
        <Chip
          size="small"
          label={<Typography>{properCase(t("other.lblApproved"))}</Typography>}
          style={{ backgroundColor: "#8DC13F1A", color: "#8DC13F" }}
        />
      );
    }
  };

  const getStatusForDay = () => {
    let weekDay = moment(args.date);
    let day = weekDay.format("dddd");
    let status = dayWiseStatus[day];
    let flagToCheckIfThereIsActivityForDay = false;
    let pendingCount = 0;
    let inProgressCount =0;
    let dayEvents = events.filter(
      (event) => moment(event.endStr).format("DDMM") == weekDay.format("DDMM")
    );
    for (let i = 0; i < dayEvents.length; i++) {
      if (dayEvents[i].endStr && moment(dayEvents[i].endStr).format("DDMM") == weekDay.format("DDMM")) {
        flagToCheckIfThereIsActivityForDay = true;
        if (
          dayEvents[i].extendedProps.outTS != "" && dayEvents[i].extendedProps.status?.toLowerCase() != "approved" &&
          dayEvents[i].extendedProps.outTS != "" && dayEvents[i].extendedProps.status?.toLowerCase() != "auto approved"
        ) {
          pendingCount +=1;
          //status = "Pending";
        }
        if (dayEvents[i].extendedProps.outTS == "") {
          //status = "In Progress";
          //break;
          inProgressCount +=1;
        }
      }
    }
    if(pendingCount >0){
      status = "Pending"
    }else if(inProgressCount>0){
      status = "In Progress"
    }
    if (!flagToCheckIfThereIsActivityForDay) {
      status = "";
    }
    return status && getHeaderStyle(status, weekDay, events);
  };
  return (
    <Grid
      container
      display="flex"
      direction="column"
      alignItems="center"
      justify="center"
      style={{ paddingBottom: 8, paddingTop: 8 }}
    >
      <Grid item>
        <Typography
          variant="body1"
          component="h6"
          style={{
            fontSize: "11px",
            color: args.isToday ? "#1a73e8" : "#70757a",
            textTransform: "uppercase",
          }}
        >
          {
          args.text.substring(0,3) ? 
          args.text.substring(0,3).toLowerCase() === "sun" ? 
          properCase(t("other.dscLblSunday")) :
          args.text.substring(0,3).toLowerCase() === "mon" ? 
          properCase(t("other.dscLblMonday")) :
          args.text.substring(0,3).toLowerCase() === "tue" ? 
          properCase(t("other.dscLblTuesday")) :
          args.text.substring(0,3).toLowerCase() === "wed" ? 
          properCase(t("other.dscLblWednesday")) :
          args.text.substring(0,3).toLowerCase() === "thu" ? 
          properCase(t("other.dscLblThursday")) :
          args.text.substring(0,3).toLowerCase() === "fri" ?  
          properCase(t("other.dscLblFriday")) :  
          args.text.substring(0,3).toLowerCase() === "sat" ?  
          properCase(t("other.dscLblSaturday")) : 
          args.text.substring(0,3) :
          "NA"
        }
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          component="div"
          variant="subtitle2"
          style={{
            fontSize: "25px",
            textAlign: "center",
            width: 46,
            height: 46,
            borderRadius: "100%",
            background: args.isToday ? "#1a73e8" : "transparent",
            color: args.isToday ? "white" : "#70757a",
            lineHeight: "46px",
            cursor: "pointer",
            // fontSize: "25px",
            letterSpacing: "-1.4px",
            textIndent: "-1.4px",
            fontVariant: "tabular-nums",
            fontFeatureSettings: `"tnum" 1`,
          }}
        >
          {moment(args.date).format("DD").replace(/^0+/, "")}
        </Typography>
      </Grid>
      <Grid item style={{ paddingTop: 8 }}>
        {/* <Typography>{getStatusForDay()}</Typography> */}
        {getStatusForDay()}
      </Grid>
    </Grid>
  );
};

export default DayHeaderContent;
